import { render, staticRenderFns } from "./Questionbank.vue?vue&type=template&id=5948d360&scoped=true"
import script from "./Questionbank.vue?vue&type=script&lang=js"
export * from "./Questionbank.vue?vue&type=script&lang=js"
import style0 from "./Questionbank.vue?vue&type=style&index=0&id=5948d360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5948d360",
  null
  
)

export default component.exports